import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-disciplina-view',
  templateUrl: './form-disciplina-view.component.html',
  styleUrls: ['./form-disciplina-view.component.css']
})
export class FormDisciplinaViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
